import Row from '@components/Row';
import styled from '@emotion/styled';

import Side from '../Side';

function BottomRow() {
    return (
        <Container fullWidth justify='flex-end' >
            <LeftSide/>
            <Bar/>
        </Container>
    );
}

const Container = styled(Row)`
    margin-top: -1px;
`;

const LeftSide = styled(Side)`
    margin-right: -2px;
    margin-top: -2px;
    transform: rotate(180deg);
`;

const Bar = styled.div`
    background-color: var(--color-gray6);
    height: 17px;
    border-bottom-right-radius: 12px;
    width: calc(100% - 104px);
    margin-top: -1px;
`;

export default BottomRow;
